export const styles = {
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '4px',
    borderRadius: '10px',
  },
};
